import Image from 'next/image';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { isMobile } from 'react-device-detect';
import { memo, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { BsXLg } from 'react-icons/bs';
import { APP_HOTEL_PAGE, APP_TOAST, Locale } from '../../../core/constants';
import Link from '../Link/Link';
import mobilePrompt from '../../../core/helpers/mobilePrompt';

type Props = {
  className?: string;
  hotelId?: string;
};

const MobilePrompt = ({ hotelId, className }: Props) => {
  const mobilePromptClassName = classNames(className);
  const downloadLink = hotelId ? APP_HOTEL_PAGE(hotelId) : APP_TOAST;
  const { t } = useTranslation();
  const router = useRouter();

  const isTopPage = router.pathname === '/';
  const isHotelPage =
    router.pathname?.startsWith('/h/') || router.pathname?.startsWith('/hotel-info/');
  const isJapanese = router.locale === Locale.JAPANESE;

  const shouldShowPrompt = mobilePrompt.isVisible() && (isTopPage || isHotelPage) && isJapanese;

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(shouldShowPrompt);
  }, [shouldShowPrompt]);

  const handleClose = () => {
    setIsVisible(false);
    mobilePrompt.close();
  };

  if (isMobile && isVisible) {
    return (
      <div className={mobilePromptClassName} data-nosnippet>
        <div className="flex items-center justify-between gap-4 bg-gradient-to-r from-[#751D00] to-[#C33000] px-4 py-3 text-gray-950">
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="flex size-6 items-center justify-center text-white"
              onClick={handleClose}
              aria-label={t('common:close')}
            >
              <BsXLg className="size-4" />
            </button>

            <div className="flex size-10 items-center">
              <Image src="/apple-touch-icon-180x180.png" alt="Tabist Logo" width={40} height={40} />
            </div>
            <div>
              <p className="text-xs font-bold text-white">{t('component:mobile_prompt.title')}</p>
              <p className="text-xs text-white">{t('component:mobile_prompt.open_with_app')}</p>
            </div>
          </div>

          <Link href={downloadLink}>
            <a
              target="_blank"
              className="btn-medium flex h-[36px] w-[90px] items-center justify-center rounded-[30px] bg-white px-4 py-1.5 text-center text-xs font-bold text-orange-700 hover:opacity-60"
            >
              {t('component:mobile_prompt.get')}
            </a>
          </Link>
        </div>
      </div>
    );
  }
  return null;
};

export default memo(MobilePrompt);
